import { css, Theme } from "@emotion/react";
import {
  fullGrid,
  gridColumn,
  section,
  topMargin,
} from "@hl/communities-app/lib/styles/global/layout";

export const layout = css`
  ${section};
  ${fullGrid};
  ${topMargin("13/64px")};
`;

export const editorCol = css`
  ${gridColumn([1, 9])};
`;

export const previewCol = css`
  ${gridColumn([9, 15])};

  display: flex;
  flex-direction: column;
`;

export const mainContainer = css`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${topMargin("9/32px")};
`;

export const previewContentContainer = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 0 48px 0;
  ${topMargin("6/16px")};
`;

export const previewContainer = (noContent: boolean) => (theme: Theme) =>
  css`
    display: flex;
    height: 100%;
    min-height: 400px;
    ${noContent ? "max-height:720px" : null};
    padding: 0;
    flex: 1 1 auto;
    overflow: hidden;
    flex-direction: column;
    ${theme.mediaQueries.smallOnly} {
      min-height: 400px;
    }
  `;

export const previewIcon = css`
  width: 16px;
  height: 16px;
`;

export const pageTabIcon = css`
  width: 20px;
  height: 20px;
`;
